// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var SiteExternalIdType;
(function (SiteExternalIdType) {
    SiteExternalIdType[SiteExternalIdType["UNKNOWN"] = 0] = "UNKNOWN";
    SiteExternalIdType[SiteExternalIdType["MEMBERID"] = 1] = "MEMBERID";
    SiteExternalIdType[SiteExternalIdType["SOCIALSECURITYNUMBERSSN"] = 2] = "SOCIALSECURITYNUMBERSSN";
    SiteExternalIdType[SiteExternalIdType["FEDERALEMPLOYERIDENTIFICATIONNUMBEREIN"] = 3] = "FEDERALEMPLOYERIDENTIFICATIONNUMBEREIN";
    SiteExternalIdType[SiteExternalIdType["DRIVERSLICENSENUMBER"] = 4] = "DRIVERSLICENSENUMBER";
    SiteExternalIdType[SiteExternalIdType["DEANUMBER"] = 5] = "DEANUMBER";
    SiteExternalIdType[SiteExternalIdType["NPINUMBER"] = 6] = "NPINUMBER";
    SiteExternalIdType[SiteExternalIdType["GROUPID"] = 7] = "GROUPID";
    SiteExternalIdType[SiteExternalIdType["EMPLOYEEID"] = 8] = "EMPLOYEEID";
    SiteExternalIdType[SiteExternalIdType["STATELICENSENUMBER"] = 9] = "STATELICENSENUMBER";
    SiteExternalIdType[SiteExternalIdType["PROCESSORCONTROLLERNUMBER"] = 10] = "PROCESSORCONTROLLERNUMBER";
    SiteExternalIdType[SiteExternalIdType["BANKIDENTIFICATIONNUMBER"] = 11] = "BANKIDENTIFICATIONNUMBER";
    SiteExternalIdType[SiteExternalIdType["MEDICALID"] = 12] = "MEDICALID";
    SiteExternalIdType[SiteExternalIdType["ISGOVERNMENT"] = 13] = "ISGOVERNMENT";
    SiteExternalIdType[SiteExternalIdType["ASSISTRXCASENUMBER"] = 14] = "ASSISTRXCASENUMBER";
    SiteExternalIdType[SiteExternalIdType["ISMEDICALBENEFIT"] = 15] = "ISMEDICALBENEFIT";
    SiteExternalIdType[SiteExternalIdType["COVERAGESTARTDATE"] = 16] = "COVERAGESTARTDATE";
    SiteExternalIdType[SiteExternalIdType["COVERAGEENDDATE"] = 17] = "COVERAGEENDDATE";
    SiteExternalIdType[SiteExternalIdType["PLANYEAR"] = 18] = "PLANYEAR";
    SiteExternalIdType[SiteExternalIdType["VirmedicaPraticeID"] = 19] = "VirmedicaPraticeID";
    SiteExternalIdType[SiteExternalIdType["VirmedicaLocationID"] = 20] = "VirmedicaLocationID";
    SiteExternalIdType[SiteExternalIdType["VirmedicaProviderID"] = 21] = "VirmedicaProviderID";
    SiteExternalIdType[SiteExternalIdType["VirmedicaHCPProviderID"] = 22] = "VirmedicaHCPProviderID";
    SiteExternalIdType[SiteExternalIdType["VirmedicaMasterPayerID"] = 23] = "VirmedicaMasterPayerID";
    SiteExternalIdType[SiteExternalIdType["VirmedicaPayerID"] = 24] = "VirmedicaPayerID";
    SiteExternalIdType[SiteExternalIdType["MaxRTEPayorID"] = 25] = "MaxRTEPayorID";
    SiteExternalIdType[SiteExternalIdType["ProviderTransactionAccessNumber"] = 26] = "ProviderTransactionAccessNumber";
})(SiteExternalIdType || (SiteExternalIdType = {}));
//# sourceMappingURL=siteExternalIdType.js.map